import { Component, OnInit } from '@angular/core';
import { DataTaskService } from '../../../core/services/data-task.service';
import { ModalService } from '../../../core/services/modal.service';
import { StateService } from '../../../core/services/state.service';

@Component({
  selector: 'tt-consignment-line',
  templateUrl: './consignment-line.component.html',
  styleUrls: ['./consignment-line.component.css']
})
export class ConsignmentLineComponent implements OnInit {
    consignmentLineKeyno;

    public edit?: Edit;

    public saving = false;

    constructor(private stateService: StateService, private modal: ModalService, private datatask: DataTaskService) {
        this.consignmentLineKeyno = this.stateService.getStateParams()['consignmentline_keyno'];
    }

    private async loadEdit() {
        if (!!this.consignmentLineKeyno) {
            this.edit = (await this.datatask.Post(331, { consignmentline_keyno: this.consignmentLineKeyno }))[0];
        }
    }

    public async saveChanges() {
        if (!!this.edit) {
            try {
                this.saving = true;

                const response = (await this.datatask.Post(437, this.edit))[0];

                if (response?.errorcode !== '0') {
                    this.modal.show({
                        type: 'warning',
                        title: 'error',
                        translateTitle: true,
                        message: response.errormessage
                    });
                } else {
                    this.stateService.back();
                }
            } finally {
                this.saving = false;
            }
        }
    }

    private async init() {
        this.loadEdit();
    }

    ngOnInit() {
        this.init();
    }
}

interface Edit {
    consignmentline_keyno: string;
    stock_keyno: string;
    quantity_topick: string;
    quantity_picked: string;
    olm_keyno: string;
    orderline_keyno: string;
    quantity_assigned: string;
    prodname_long: string;
    poh_keyno_top: string;
    prodsize_keyno: string;
    volum_picked: string;
    weight_picked: string;
    quantity_picked_colli: string;
    nbr_of_consignmentlinesb: string;
    planpolicy_no: string;
    change_component_is_possible: string;
    quantity_packed: string;
}
